import { RouterStore } from '@superwf/mobx-react-router';
import { SSOClient } from '../CommonInterfaces';
import AddEmailStore from './AddEmailStore';
import BanksLoginStore from './BanksLoginStore';
import DealerLoginStore from './DealerLoginStore';
import { DealerPreferencesStore } from './DealerPreferencesStore';
import { DealerRepresentationStore } from './DealerRepresentationStore';
import { DealerSetRepresentationStore } from './DealerSetRepresentationStore';
import EmailLoginStore from './EmailLoginStore';
import EmailRegisterStore from './EmailRegisterStore';
import EmailRemoveStore from './EmailRemoveStore';
import ForgotPasswordStore from './ForgotPasswordStore';
import { HomeStore } from './HomeStore';
import IdCardLoginStore from './IdCardLoginStore';
import LanguageStore from './LanguageStore';
import LoginReturnStore from './LoginReturnStore';
import LogoutStore from './LogoutStore';
import MandateStore from './MandateStore';
import MergeStore from './MergeStore';
import MobileIdLoginStore from './MobileIdLoginStore';
import PasskeyStore from './PasskeyStore';
import PasswordChangeStore from './PasswordChangeStore';
import PersonalCodeLoginStore from './PersonalCodeLoginStore';
import RememberMeStore from './RememberMeStore';
import ResetPasswordStore from './ResetPasswordStore';
import RouteStore from './RouteStore';
import SessionTransferStore from './SessionTransferStore';
import SmartIdLoginStore from './SmartIdLoginStore';
import SmsLoginStore from './SmsLoginStore';
import TranslateStore from './TranslateStore';
import UiStore from './UiStore';
import AccountInfoStore from './AccountInfoStore';

export class RootStore {
  public router: RouterStore;
  public client?: SSOClient;
  public routeStore: RouteStore;
  public dealerPreferencesStore: DealerPreferencesStore;
  public uiStore: UiStore;
  public languageStore: LanguageStore;
  public translateStore: TranslateStore;
  public dealerRepresentationStore: DealerRepresentationStore;
  public dealerSetRepresentationStore: DealerSetRepresentationStore;
  public homeStore: HomeStore;
  public personalCodeLoginStore: PersonalCodeLoginStore;
  public mobileIdLoginStore: MobileIdLoginStore;
  public smartIdLoginStore: SmartIdLoginStore;
  public idCardLoginStore: IdCardLoginStore;
  public mandateStore: MandateStore;
  public logoutStore: LogoutStore;
  public loginReturnStore: LoginReturnStore;
  public banksLoginStore: BanksLoginStore;
  public dealerLoginStore: DealerLoginStore;
  public emailLoginStore: EmailLoginStore;
  public emailRegisterStore: EmailRegisterStore;
  public rememberMeStore: RememberMeStore;
  public addEmailStore: AddEmailStore;
  public emailRemoveStore: EmailRemoveStore;
  public mergeStore: MergeStore;
  public forgotPasswordStore: ForgotPasswordStore;
  public passwordChangeStore: PasswordChangeStore;
  public resetPasswordStore: ResetPasswordStore;
  public sessionTransferStore: SessionTransferStore;
  public accountInfoStore: AccountInfoStore;
  public smsLoginStore: SmsLoginStore;
  public passkeyStore: PasskeyStore;

  constructor(routing: RouterStore, client?: SSOClient) {
    this.router = routing;
    this.client = client;
    this.rememberMeStore = new RememberMeStore();
    this.routeStore = new RouteStore(this);
    this.uiStore = new UiStore();
    this.languageStore = new LanguageStore(this);
    this.translateStore = new TranslateStore(this);
    this.accountInfoStore = new AccountInfoStore();
    this.mergeStore = new MergeStore(this);
    this.homeStore = new HomeStore(this);
    this.dealerRepresentationStore = new DealerRepresentationStore(this);
    this.dealerPreferencesStore = new DealerPreferencesStore(this);
    this.dealerSetRepresentationStore = new DealerSetRepresentationStore();
    this.passkeyStore = new PasskeyStore(this);
    this.personalCodeLoginStore = new PersonalCodeLoginStore(this);
    this.mobileIdLoginStore = new MobileIdLoginStore(this);
    this.smartIdLoginStore = new SmartIdLoginStore(this);
    this.idCardLoginStore = new IdCardLoginStore(this);
    this.mandateStore = new MandateStore(this);
    this.logoutStore = new LogoutStore(this);
    this.loginReturnStore = new LoginReturnStore(this);
    this.banksLoginStore = new BanksLoginStore(this);
    this.dealerLoginStore = new DealerLoginStore(this);
    this.emailLoginStore = new EmailLoginStore(this);
    this.emailRegisterStore = new EmailRegisterStore(this);
    this.emailRemoveStore = new EmailRemoveStore(this);
    this.addEmailStore = new AddEmailStore(this);
    this.forgotPasswordStore = new ForgotPasswordStore(this);
    this.passwordChangeStore = new PasswordChangeStore(this);
    this.resetPasswordStore = new ResetPasswordStore(this);
    this.sessionTransferStore = new SessionTransferStore(this);
    this.smsLoginStore = new SmsLoginStore(this);
  }
}

export default RootStore;
